// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-orange a[data-v-47538e7e]:hover{color:#f37b1d;text-decoration:none}.text-red[data-v-47538e7e]{color:red;text-decoration:none}.contact-way>div[data-v-47538e7e]{margin-left:50px}", ""]);
// Exports
module.exports = exports;
